import { memo, useMemo } from 'react'
import { useHideOtherPairs } from 'store/orderbook/hooks'
import { useCurrentSpotSymbol, useSpotOpenOrders } from 'store/spot/hooks'
import { Equal } from '../../../../utils/equal'
import { SpotOpenOrderList } from './List'

export const OpenOrderView = memo(() => {
  const currentSpotSymbol = useCurrentSpotSymbol()
  const list = useSpotOpenOrders()
  const { name } = currentSpotSymbol ?? {}
  const hideOtherPairs = useHideOtherPairs()

  const renderList = useMemo(() => {
    if (hideOtherPairs && !!name)
      return list.filter((v) => Equal.upperCase(v.symbol, name))
    return list
  }, [list, hideOtherPairs, name])

  return <SpotOpenOrderList rows={renderList} />
})
